<template>
    <main>
        <v-layout align-center row wrap
                  justify-space-between
                  :class="{'mx-3': $vuetify.breakpoint.smAndDown}"
        >
            <v-flex>
                <h1 class="section-title-main my-3 mr-4 font-weight-regular">{{$t("Мои уведомления")}}</h1>
            </v-flex>
            <v-flex>
                <linkIcon icon="bell" class="notifications__edit-block mr-4" @click="goto">{{$t("Настроить уведомления")}}</linkIcon>
            </v-flex>
        </v-layout>
        <v-layout v-if="notifications" row wrap
                  class="notifications_container"
                  :class="{'mx-3': $vuetify.breakpoint.smAndDown}"
        >
            <v-flex md12 lg12 class="news">
                <div class="news__wrap  mb-4">
                    <NoteNew />
                    <NoteAnother />
                </div>
            </v-flex>
        </v-layout>
    </main>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';

import LiveNewsBlock from '@/components/view_blocks/Live_news/Live_news_block';
import NoteNew from '@/components/blocks/Notifications/notifications_new.vue';
import NoteAnother from '@/components/blocks/Notifications/notifications_another.vue';
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import VBar from 'v-bar';

export default {
  components: {
    LiveNewsBlock,
    NoteNew,
    NoteAnother,
    linkIcon,
    VBar,
    buttonBdWhite,
  },
  data() {
    return {
      index: 0,
      page : 0,
    };
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
    ...mapGetters('notifications/Notifications_items', ['chunks', 'notifications']),
    ...mapGetters('live_news', [
      'paginated',
    ]),
  },
  methods: {
    get_index(page) {
      this.index = page-1;
    },
    goto() {
      this.$router.push({name: 'note_edit'});
    },
  },
};
</script>
